const ConnectWalletIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.82987 7.58919V6.36963C7.82987 4.34899 9.44165 2.71094 11.4299 2.71094H13.8299C15.8181 2.71094 17.4299 4.34899 17.4299 6.36963V7.58919H19.8299C21.1553 7.58919 22.2299 8.68123 22.2299 10.0283V14.3831C19.2414 15.5099 16.0077 16.1261 12.6299 16.1261C9.25205 16.1261 6.01831 15.5099 3.02988 14.3831V10.0283C3.02988 8.68123 4.10439 7.58919 5.42987 7.58919H7.82987ZM10.2299 6.36963C10.2299 5.69608 10.7671 5.15007 11.4299 5.15007H13.8299C14.4926 5.15007 15.0299 5.69608 15.0299 6.36963V7.58919H10.2299V6.36963ZM11.4299 12.4674C11.4299 11.7939 11.9671 11.2479 12.6299 11.2479H12.6419C13.3046 11.2479 13.8419 11.7939 13.8419 12.4674C13.8419 13.141 13.3046 13.687 12.6419 13.687H12.6299C11.9671 13.687 11.4299 13.141 11.4299 12.4674Z"
      fill="white"
    />
    <path
      d="M3.02988 16.9704V19.7848C3.02988 21.1319 4.10439 22.224 5.42987 22.224H19.8299C21.1553 22.224 22.2299 21.1319 22.2299 19.7848V16.9704C19.2145 18.0048 15.9856 18.5652 12.6299 18.5652C9.27422 18.5652 6.04523 18.0048 3.02988 16.9704Z"
      fill="white"
    />
  </svg>
);

export default ConnectWalletIcon;